"use client"

import { BookImage } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookImageIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookImageIcon = component(Icon)({ as: BookImage })
